import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { Box, Button } from '@mui/material';

// Components
import { MDropdown } from 'common';

// Utils
import { FILTER_ALL } from 'utils/constants';

const FilterPopover = props => {
  const {
    filterOptions: {
      affiliateListDropdown,
      locations,
      dataCompanyOptions,
      originatorOptions,
      recipientOptions,
      transferDates,
    },
    filters,
    handleClose,
    numberFuturePtos,
    resetFilters,
    setFilters,
    openPtoList,
  } = props;

  const { affiliate, dataCompany, location, originator, recipient, transferDate } = filters;

  const showClear = Object.keys(filters).some(key => filters[key] !== FILTER_ALL);
  const showAffiliates = openPtoList.length > 1 && affiliateListDropdown.length > 2;

  const handleClear = () => {
    resetFilters();
    handleClose();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mx: 4,
        my: 2,
        pt: 2,
        width: 200,
      }}
    >
      {showAffiliates && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="affiliate-select"
          items={affiliateListDropdown}
          label="Affiliate"
          name="affiliate"
          onChange={setFilters}
          value={affiliate}
        />
      )}
      {locations.length > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: !showAffiliates ? 0 : 2,
            width: 200,
          }}
        >
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="location-select"
            items={locations}
            label="Location"
            name="location"
            onChange={setFilters}
            value={location}
          />
        </Box>
      )}
      {numberFuturePtos > 0 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2,
            width: 200,
          }}
        >
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="transferDate-select"
            items={transferDates}
            label="Transfer Date"
            name="transferDate"
            onChange={setFilters}
            value={transferDate}
          />
        </Box>
      )}
      {dataCompanyOptions.length > 2 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2,
            width: 200,
          }}
        >
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="system-select"
            items={dataCompanyOptions}
            label="System"
            name="dataCompany"
            onChange={setFilters}
            value={dataCompany}
          />
        </Box>
      )}
      {recipientOptions.length > 2 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2,
            width: 200,
          }}
        >
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="recipient-select"
            items={recipientOptions}
            label="Recipient"
            name="recipient"
            onChange={setFilters}
            value={recipient}
          />
        </Box>
      )}
      {originatorOptions.length > 2 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2,
            width: 200,
          }}
        >
          <MDropdown
            anchorOrigin={{
              horizontal: 'center',
              vertical: 'top',
            }}
            id="originator-select"
            items={originatorOptions}
            label="Originator"
            name="originator"
            onChange={setFilters}
            value={originator}
          />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          pt: 2,
          width: 200,
        }}
      >
        {showClear && (
          <Button aria-label="Clear" onClick={handleClear} variant="text">
            Clear
          </Button>
        )}
      </Box>
    </Box>
  );
};

FilterPopover.propTypes = {
  filterOptions: shape({
    affiliateListDropdown: arrayOf(shape({})).isRequired,
    dataCompanyOptions: arrayOf(shape({})).isRequired,
    locations: arrayOf(shape({})).isRequired,
    originatorOptions: arrayOf(shape({})).isRequired,
    recipientOptions: arrayOf(shape({})).isRequired,
    transferDates: arrayOf(shape({})).isRequired,
  }).isRequired,
  filters: shape({
    affiliate: string,
    dataCompany: string,
    location: string,
    originator: string,
    recipient: string,
    transferDate: string,
  }).isRequired,
  handleClose: func.isRequired,
  numberFuturePtos: number.isRequired,
  openPtoList: arrayOf(shape({})).isRequired,
  resetFilters: func.isRequired,
  setFilters: func.isRequired,
};

export default FilterPopover;
